import React from 'react'

import IFormFieldProps from 'interfaces/form-field-props'
import 'react-datepicker/dist/react-datepicker.css'

import styles from './CheckBoxRadioButtonInput.module.scss'
interface ICheckBoxRadioButtonInputProps
  extends IFormFieldProps<React.ChangeEventHandler<HTMLInputElement>> {
  inline?: boolean
  type: any
  checked?: boolean
  onBlur?: any
  customLabel?: any
  onClick?: any
  className?: string
}

const CheckBoxRadioButtonInput: React.FC<ICheckBoxRadioButtonInputProps> = ({
  name,
  className = '',
  value = true,
  disabled = false,
  label = '',
  inline = false,
  type,
  onChange,
  onBlur = undefined,
  checked,
  customLabel = undefined,
  onClick = undefined,
}) => {
  return (
    <>
      <div
        className={`  ${className} custom-control  custom-${type || 'radio'} ${
          inline ? styles.inline : ''
        }`}
      >
        <input
          id={name}
          className={`custom-control-input`}
          type={type || 'radio'}
          name={name}
          value={value}
          disabled={disabled}
          checked={checked}
          onBlur={onBlur || null}
          onChange={onChange}
          onClick={(e) => !disabled && onClick?.(e)}
        />
        <label
          className={`${styles.customControlLabel} ${styles.text} custom-control-label`}
          htmlFor={name}
        >
          {label}
        </label>
        {customLabel && (
          <label className={styles.customControlLabel} htmlFor={name}>
            {customLabel}
          </label>
        )}
      </div>
    </>
  )
}

export default CheckBoxRadioButtonInput
